import React, { useEffect, useState } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { getCurrentAuthUser } from '../../utils/auth';
import { trackEvent } from '../../utils/analytics';

interface ProtectedRouteProps {
  children: React.ReactNode;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children }) => {
  const [isAuthenticated, setIsAuthenticated] = useState<boolean | null>(null);
  const location = useLocation();

  useEffect(() => {
    const checkAuth = async () => {
      try {
        const user = await getCurrentAuthUser();
        const isAuthed = !!user;
        setIsAuthenticated(isAuthed);
        
        if (!isAuthed) {
          // Track unauthorized access attempt
          trackEvent('unauthorized_access_attempt', {
            path: location.pathname
          });
        }
      } catch (error) {
        console.error('Error checking auth status:', error);
        setIsAuthenticated(false);
      }
    };
    
    checkAuth();
  }, [location.pathname]);

  if (isAuthenticated === null) {
    // Still checking auth status
    return null;
  }

  if (!isAuthenticated) {
    // Redirect to auth page with return_to parameter
    return <Navigate to="/auth" state={{ from: location }} replace />;
  }

  return <>{children}</>;
};

export default ProtectedRoute; 